import React from 'react';
import { Text, View, Image, StyleSheet, Link } from '@react-pdf/renderer';
import LogoImage from "pages/pledgxOutputPDF/images/pledgx_logo.png";

const styles = StyleSheet.create({
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 50,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF',
        padding: 10,
        fontSize: 12,
        opacity: 0.6,
    },
    image: {
        height: 25,
        width: 76,
        marginTop: -5
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 3,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 8,
        color:'#1A051D',
        paddingTop: 20,
    },
});

const PdfFooterHomePage = () => {
    const href = "https://pledgx.ai"
    return (
        <div  style={styles.footer}>
            <View style={styles.footer}>
                <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Text style={{ marginLeft: 25, fontSize: 8 }}>{new Date().toLocaleDateString()}</Text>
                    <View style={{ display: 'flex', flexDirection: 'row' }}>
                        <Text style={{ fontSize: 12, paddingTop: 3, paddingLeft: 350, color: '#1A051D' }}>Powered by </Text>
                        <Link href={href}>
                            <Image src={LogoImage} style={[styles.image, { marginRight: 5 }]} />
                        </Link>
                    </View>
                    <Text style={styles.pageNumbers} render={({ pageNumber, totalPages }) => (
                    `${pageNumber} / ${totalPages}`
                )} />
                </View>
            </View>
        </div>
    );
};

export default PdfFooterHomePage;